module.exports = __webpack_public_path__ + "img/preview.2ebb88e6.svg";